import { Backdrop } from "@mui/material";
import { CircularProgress } from "@mui/material";

const Loader = ({ isLoading = false, isAnimation = false }) => {
  if(isAnimation){
    return null;
  }
  return (
    <Backdrop
      open={isLoading}
      // Above every MUI overlay layer, including open Dialogs.
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.tooltip + 1 }}
    >
      <CircularProgress color="secondary" />
    </Backdrop>
  );
};

export default Loader;
